import { render, staticRenderFns } from "./UploadedReferralNotes.vue?vue&type=template&id=26ac9f2c&scoped=true&"
import script from "./UploadedReferralNotes.vue?vue&type=script&lang=js&"
export * from "./UploadedReferralNotes.vue?vue&type=script&lang=js&"
import style0 from "./UploadedReferralNotes.vue?vue&type=style&index=0&id=26ac9f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ac9f2c",
  null
  
)

export default component.exports